// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3zQqX","title":"FrontImage_title__3dUr0"};